import { THEME_STORAGE_KEY, ThemeProvider } from '@/features/layout/theme/theme-provider';
import { Toaster } from '@/ui/sonner';
import { useThemeMode } from '@/features/layout/theme/useThemeMode';

export default function Layout({ children }: { children: React.ReactNode }): React.JSX.Element {
  const isDark = useThemeMode();

  return (
    <ThemeProvider defaultTheme='light' storageKey={THEME_STORAGE_KEY}>
      {children}
      <Toaster
        position='bottom-left'
        expand={true}
        richColors={false}
        theme={isDark ? 'dark' : 'light'}
      />
    </ThemeProvider>
  );
}
